import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
// COMPONENTS
import SectionHeader from 'components/text/SectionHeader';
// import LoadingCards from './LoadingCards';
import StatCard from './StatCard';
// APOLLO
import dashboardStatsQuery from 'ApolloClient/Queries/dashboardStats';
import { graphql, compose } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

// new leads in the last 30 days
// invoices paid in the last 30 days
// Sessions on your calendar in the next 30 days

// CONSTANTS
// ===================================

// EXPORTED COMPONENT
// ===================================
export class StudioDashboard extends React.PureComponent {
  onCurrencyChange = browsingCurrency => {
    this.props.onUiStoreChange({
      browsingCurrency,
    });
  };

  render() {
    const { dashboardStats } = this.props.dashboardStatsQuery;

    // if (dashboardStatsQuery.loading) {
    //   return <LoadingCards />;
    // }

    return (
      <div>
        <div style={{ position: 'relative' }}>
          <SectionHeader>Studio Dashboard</SectionHeader>
          <div style={s.currencyContainer}>
            {/* <SelectCurrency
              value={uiStore.browsingCurrency}
              onChange={this.onCurrencyChange}
            /> */}
          </div>
        </div>
        <Row gutter={20} type="flex" style={s.placeholder} align="middle" justify="flex-start">
          {dashboardStats.map(item => (
            <Col key={item._id} xs={24} sm={8} style={{ marginBottom: 10 }}>
              <StatCard {...item} history={this.props.history} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

// STYLES
// ===================================
const s = {
  placeholder: {
    minHeight: 165,
  },
  currencyContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
};

// REDUX
// ===================================

// PROPS
// ===================================
StudioDashboard.propTypes = {
  uiStore: PropTypes.shape({
    browsingCurrency: PropTypes.string.isRequired,
  }),
  dashboardStatsQuery: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    dashboardStats: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        tooltipText: PropTypes.string.isRequired,
        linkTo: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        iconType: PropTypes.string.isRequired,
        backgroundColor: PropTypes.string.isRequired,
      }),
    ),
  }),
};

// APOLLO
// ===================================
let options = props => ({
  fetchPolicy: 'cache-and-network', // we add this to make sure apollo reruns the query when the browsing currency changes
});

// EXPORT
// ===================================
export default compose(
  graphql(dashboardStatsQuery, { options, name: 'dashboardStatsQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'dashboardStatsQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'dashboardStatsQuery' }),
)(StudioDashboard);



// WEBPACK FOOTER //
// ./src/routes/app-home/StudioDashboard/index.js